var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3Star(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 34,
    viewBox: "0 0 182 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 24.466L25.7549 29.7502L23.4316 19.791L31.1666 13.0902L20.9808 12.2118L16.9999 2.8335L13.0191 12.2118L2.83325 13.0902L10.5541 19.791L8.24492 29.7502L16.9999 24.466Z",
    fill: "#FECC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9999 24.466L99.7549 29.7502L97.4316 19.791L105.167 13.0902L94.9808 12.2118L90.9999 2.8335L87.0191 12.2118L76.8333 13.0902L84.5541 19.791L82.2449 29.7502L90.9999 24.466Z",
    fill: "#FECC00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165 24.466L173.755 29.7502L171.432 19.791L179.167 13.0902L168.981 12.2118L165 2.8335L161.019 12.2118L150.833 13.0902L158.554 19.791L156.245 29.7502L165 24.466Z",
    fill: "#CFCFCF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9999 24.466L62.7549 29.7502L60.4316 19.791L68.1666 13.0902L57.9808 12.2118L53.9999 2.8335L50.0191 12.2118L39.8333 13.0902L47.5541 19.791L45.2449 29.7502L53.9999 24.466Z",
    fill: "#FECC00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128 24.466L136.755 29.7502L134.432 19.791L142.167 13.0902L131.981 12.2118L128 2.8335L124.019 12.2118L113.833 13.0902L121.554 19.791L119.245 29.7502L128 24.466Z",
    fill: "#CFCFCF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Star);
export default __webpack_public_path__ + "static/media/3star.138fa6ab1f686af88f0c106eda08d147.svg";
export { ForwardRef as ReactComponent };